import { FC } from 'react'
import Styles from './Body.module.scss'

const Body: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={Styles.body}>{children}</div>
}

export { Body }
